import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Eye, Link2Off } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { logoUrl } from "@/lib/social";
import { PostTable } from "@/components/social/PostTable";
import { PostReviewModal } from "@/components/social/PostReviewModal";
import { InstagramGrid, ViewSwitch, igAccounts } from "@/components/social/InstagramGrid";

export default function PublicSocialReview() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [open, setOpen] = useState(null);
  const [view, setView] = useState("table");
  useEffect(() => { api.get(`/public/social-review/${token}`).then(({ data }) => setD(data)).catch((e) => setErr(formatApiError(e.response?.data?.detail))); }, [token]);
  if (err) return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 px-6 text-center bg-[#F6F6FD]" data-testid="public-social-expired">
      <Link2Off className="h-8 w-8 text-[#c4c5cc]" /><p className="text-sm text-[#595D62] max-w-xs">{err}</p>
    </div>
  );
  if (!d) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#c4c5cc]" /></div>;
  const post = open && d.posts.find((p) => p.id === open);
  const logo = logoUrl(d.workspace);
  return (
    <div className="min-h-screen bg-white" data-testid="public-social-review">
      <header className="border-b border-[#f0f0f3] px-4 sm:px-8 h-16 flex items-center gap-3">
        {logo ? <img src={logo} alt="" className="h-8 w-8 rounded-lg object-cover" /> : <span className="h-8 w-8 rounded-lg bg-[#06060C] text-white flex items-center justify-center text-sm font-semibold">{(d.workspace?.name || "?").slice(0, 1)}</span>}
        <span className="text-sm font-medium text-[#06060C] truncate">{d.workspace?.name}</span>
      </header>
      <main className="px-4 sm:px-8 py-6 sm:py-10 max-w-7xl mx-auto space-y-5">
        <div className="flex items-end gap-4 flex-wrap">
          <div className="basis-full sm:basis-0 sm:flex-1 min-w-0">
            <h1 className="font-display text-2xl sm:text-3xl md:text-4xl font-semibold tracking-tight text-[#06060C] break-words" data-testid="public-social-title">{d.group.name}</h1>
            <p className="text-sm text-[#595D62] mt-1.5 flex items-center gap-1.5"><Eye className="h-4 w-4 shrink-0" /> Preview of {d.posts.length} post{d.posts.length === 1 ? "" : "s"}. Tap a post to see it in full.</p>
          </div>
          <ViewSwitch view={view} onChange={setView} show={igAccounts(d.posts, d.accounts).length > 0} />
        </div>
        {view === "grid" && igAccounts(d.posts, d.accounts).length ? <InstagramGrid posts={d.posts} accounts={d.accounts} ws={d.workspace} onOpen={(p) => setOpen(p.id)} />
          : <PostTable posts={d.posts} accounts={d.accounts} ws={d.workspace} client readOnly onOpen={(p) => setOpen(p.id)} />}
      </main>
      {post && <PostReviewModal post={post} accounts={d.accounts} ws={d.workspace} readOnly onClose={() => setOpen(null)} onChanged={() => {}} />}
    </div>
  );
}
